module.exports = __webpack_public_path__ + "img/8k.793aca44.jpg";